import gql from 'graphql-tag';

const NOTIFICATION_DELETE = gql`
mutation notificationCancel($id: ID!){
    notificationCancel(id:$id)
}
`;

export default NOTIFICATION_DELETE;
